var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewFolder = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 6a4 4 0 0 1 4-4h5.892a4 4 0 0 1 2.058.57L16 5h12a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4zm16 6c.621 0 1.125.504 1.125 1.125v3.75h3.75a1.125 1.125 0 0 1 0 2.25h-3.75v3.75a1.125 1.125 0 0 1-2.25 0v-3.75h-3.75a1.125 1.125 0 0 1 0-2.25h3.75v-3.75c0-.621.504-1.125 1.125-1.125"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewFolder);
export default ForwardRef;